import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { 
    TextField,
    Grid,
    CardContent,
    Card,
    List,
    ListItem,
    Typography,
    Icon,
    IconButton,
} from '@material-ui/core';


const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {},
    draggableList: {
        height:       '600px',
        background:   theme.palette.background.default,
        padding:      grid,
        borderRadius: '25px',
        overflow:     'auto',
    },
});

const grid = 8;

const getListStyle = (isDraggingOver) => {
    if (isDraggingOver) {
        return {
            background: 'lightblue',
        }
    }
};

class OrderAnswer extends Component {

    handleChange = (field_name, answer_id) => (event) => {
        const { answer, question, updateAnswer } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox' || event.target.type === 'radio') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateAnswer(question.header.question_id, answer_id, update_data);
    }

    onDragEnd = (result) => {
        const { question } = this.props;
        const { source, destination } = result;

        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            this.props.reorderAnswerList(source.droppableId, question.header.question_id, source.index, destination.index);
        } else {
            this.props.swapAnswerList(question.header.question_id, source, destination);
        }
    }

    handleDeleteAnswer = (event, answer_id) => {
        const { question } = this.props;
        
        event.preventDefault();
        event.stopPropagation();

        this.props.deleteAnswer(question.header.question_id, answer_id);
    }

    generateAnswerCard = (answer, index, type) => {
        const { view_type } = this.props;
        
        if(type === 'correct') {
            return (
                <Card style={{ width: '100%' }}>
                    <CardContent>
                        <Grid container spacing={8}>
                            <Grid item xs={1}>
                                {index + 1}
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    label="Answer Text"
                                    margin="normal"
                                    variant="outlined"
                                    value={answer.header.AnswerText}
                                    onChange={this.handleChange('AnswerText', answer.header.answer_id)}
                                    style={{ width: '100%' }}
                                    multiline={true}
                                    rowsMax={6}
                                    autoFocus
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <IconButton
                                    variant="contained"
                                    onClick={(event) => this.handleDeleteAnswer(event, answer.header.answer_id)}
                                    disabled={view_type === 'detail'}
                                    hidden={view_type === 'detail'}
                                >
                                    <Icon style={{ fontSize: 20 }}>delete</Icon>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        } else {
            return (
                <Card style={{ width: '100%' }}>
                    <CardContent>
                        <Grid container spacing={8}>
                            <Grid item xs={10}>
                                <TextField
                                    label="Answer Text"
                                    margin="normal"
                                    variant="outlined"
                                    value={answer.header.AnswerText}
                                    onChange={this.handleChange('AnswerText', answer.header.answer_id)}
                                    style={{ width: '100%' }}
                                    multiline={true}
                                    rowsMax={6}
                                    autoFocus
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <IconButton
                                    variant="contained"
                                    onClick={(event) => this.handleDeleteAnswer(event, answer.header.answer_id)}
                                    disabled={view_type === 'detail'}
                                    hidden={view_type === 'detail'}
                                >
                                    <Icon style={{ fontSize: 20 }}>delete</Icon>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        }
        
    }

    render() {
        const { classes, question, view_type } = this.props;
        if(typeof question === 'undefined') {
            return (<div>error</div>);
        }

        return (
            <React.Fragment>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Grid container spacing={16}>
                        <Grid item xs={6}>
                            <Droppable droppableId="wrong">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={classes.draggableList}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        <Typography variant="h6" align="center">Select From the Following</Typography>
                                        <List>
                                            {question.wrongList.map((answer, index) => (
                                                <Draggable
                                                    key={answer.header.answer_id}
                                                    draggableId={answer.header.answer_id}
                                                    index={index}
                                                    listType='wrong'
                                                    isDragDisabled={view_type === 'detail'}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <ListItem>
                                                                {this.generateAnswerCard(answer, index, 'wrong')}
                                                            </ListItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                        <Grid item xs={6}>
                            <Droppable droppableId="correct">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={classes.draggableList}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        <Typography variant="h6" align="center">Arrange in Correct Order</Typography>
                                        <List>
                                            {question.correctList.map((answer, index) => (
                                                <Draggable
                                                    key={answer.header.answer_id}
                                                    draggableId={answer.header.answer_id}
                                                    index={index}
                                                    listType='correct'
                                                    isDragDisabled={view_type === 'detail'}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <ListItem>
                                                                {this.generateAnswerCard(answer, index, 'correct')}
                                                            </ListItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                    </Grid>
                </DragDropContext>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAnswer:      Actions.updateAnswer,
        deleteAnswer:      Actions.deleteAnswer,
        moveAnswer:        Actions.moveAnswer,
        reorderAnswerList: Actions.reorderAnswerList,
        swapAnswerList:    Actions.swapAnswerList,
    }, dispatch);
}

function mapStateToProps({ quizApp, questionApp, paramHistory }) {
    return {
        questionTypes: questionApp.questions.questionTypes,
        paramHistory:  paramHistory.courseBuilder
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderAnswer)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/questionType/OrderAnswer.js